<template>
  <div class="category-live">
    <div class="group__title flex items-center">
      <h2 class="title flex-1">
        {{ category.title }}
      </h2>
      <nuxt-link
        type="text"
        class="more-btn flex justify-center items-center cursor-pointer"
        aria-label="go academy detail"
        :to="{
          name: PageKey.ACADEMY_COLLECTION,
          params: { collection: `${category.outer_id}-${category.id}` },
        }"
      >
        {{ $t('cha-kan-geng-duo') }}
        <iconpark-icon name="arrowright" size="16"></iconpark-icon>
      </nuxt-link>
    </div>
    <div class="group__content">
      <LiveCard v-for="card in displayList" :key="card.id" :card="card" :category="category" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { IHelpCategory } from '~/api/module/help-center';
import { PageKey } from '~/constants/page';
import { useTime } from '~/hooks/useTime';
import LiveCard from '~/components/content/LiveCard.vue';
import { getLiveList } from './util';

const props = defineProps<{
  category: IHelpCategory;
}>();

const { $dayjs } = useTime();
const { $t } = useNuxtApp();

const displayList = computed(() => {
  return getLiveList($dayjs, props.category.magic_school_detail || []).slice(0, 4);
});
</script>

<style lang="scss" scoped>
.group {
  &__title {
    h2 {
      font-size: 18px;
      line-height: 1.4;
      color: var(--text-1);
    }
    .more-btn {
      font-size: 14px;
      line-height: 1;
      color: var(--text-1);
      opacity: 0.6;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  &__content {
    display: grid;
    grid-template-columns: repeat(4, minmax(56px, 1fr));
  }
}
</style>
